import { motion, AnimatePresence } from "framer-motion";
import { Bell } from "lucide-react";

export function NewStopBanner({ banner, onDismiss }) {
  if (!banner) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: -20, scale: 0.95 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: -20, scale: 0.95 }}
        className="mt-3"
      >
        <div 
          data-testid="new-stop-banner"
          className="bg-gradient-to-r from-red-600 to-red-500 text-white px-4 py-5 rounded-xl shadow-2xl flex flex-col items-center justify-center gap-2 cursor-pointer border-4 border-white/30"
          onClick={onDismiss}
        >
          <div className="flex items-center gap-3">
            <Bell className="w-8 h-8 animate-bounce" />
            <span className="font-black text-2xl tracking-wide">{banner.message}</span>
            <Bell className="w-8 h-8 animate-bounce" />
          </div>
          <span className="text-sm opacity-90 animate-pulse">TAP TO DISMISS</span>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
